export enum EntityTypeEnum {
  CUSTOMER = 'CUSTOMER',
  PLANT='PLANT',
  PROJECT = 'PROJECT',
  PROJECT_PLUS = 'PROJECT_PLUS',
}
